import React from 'react';
import NutritionApp from './NutritionApp';
import { PREEMIE_NUTRITION_VARIANT } from './variants';

/**
 * "תזונת פגים" — the original nutrition calculator.
 *
 * The implementation lives in `NutritionApp.tsx` and is shared with
 * `apps/NicuNutrition/NicuNutrition.tsx`; only the variant differs (title +
 * which AppConfig rows the formulas come from).
 */
const PreemieNutritionApp: React.FC<{ hospital?: string }> = ({ hospital }) => (
    <NutritionApp hospital={hospital} variant={PREEMIE_NUTRITION_VARIANT} />
);

export default PreemieNutritionApp;
